import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { IArticleBase } from '@/types'
import { NoContent } from '@/componentsV2/atoms/NoContent'
import { ArticleCard } from '@components-v2/molecules/ArticleCard'
import styles from './index.module.scss'

type Props = {
  articles: IArticleBase[]
}

export const UserProfileArticles: FC<Props> = ({ articles }) => {
  const { t } = useTranslation(['p'])

  return (
    <div className={styles.container}>
      {articles.length === 0 ? (
        <NoContent>{t('ストーリーがまだ登録されていません。')}</NoContent>
      ) : (
        <div className={styles.content}>
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      )}
    </div>
  )
}
